// Configuraciones de platos deconstruidos para <DeconstructedDish />

export const GILDA_DECONSTRUCTED = {
  id: 'gilda-deconstruida',
  eyebrow: 'Receta deconstruida',
  titleParts: ['Una ', { em: 'gilda' }, ', cuatro orígenes.'],
  sub: 'Cada ingrediente tiene un sitio. Mira de dónde viene cada parte de nuestra Clásica.',
  plateImg: '/dishes/gilda.jpg',
  plateAlt: 'Gilda deconstruida — anchoa de Santoña, oliva manzanilla, piparra verde y palillo',
  ingredients: [
    {
      key: 'anchoa',
      name: 'Anchoa',
      pos: 'tl', // top-left
      origin: 'Santoña · Cantabria',
      distance: '60 km',
      note: 'Bocarte del Cantábrico talla 0–00. Curado en barril durante meses, fileteado a mano. DOP.',
      img: '/dishes/ing-anchoa.jpg',
    },
    {
      key: 'oliva',
      name: 'Oliva manzanilla',
      pos: 'tr',
      origin: 'Sevilla · Andalucía',
      distance: '850 km',
      note: 'Manzanilla fina, deshuesada y rellena. Carnosa, ligeramente amarga, esencial.',
      img: '/dishes/ing-oliva.jpg',
    },
    {
      key: 'piparra',
      name: 'Piparra verde',
      pos: 'bl',
      origin: 'Ibarra · País Vasco',
      distance: '180 km',
      note: 'Piparra de Ibarra en vinagre. Verde, suave, crujiente. El tercer vértice de la trinidad.',
      img: '/dishes/ing-piparra.jpg',
    },
    {
      key: 'palillo',
      name: 'Palillo',
      pos: 'br',
      origin: 'Madera local',
      distance: '— km',
      note: 'El hilo conductor. Sin él, no hay gilda. La estructura del bocado.',
      img: '/dishes/ing-palillo.jpg',
    },
  ],
  map: {
    center: { x: 280, y: 175 },
    markers: [
      { key: 'center',    x: 280, y: 175, label: 'Torrelavega', center: true },
      { key: 'anchoa',    x: 340, y: 130, label: 'Santoña',  km: 60 },
      { key: 'piparra',   x: 440, y: 145, label: 'Ibarra',   km: 180 },
      { key: 'oliva',     x: 130, y: 270, label: 'Sevilla',  km: 850 },
    ],
  },
  mapNote: 'La anchoa viaja 60 km. La piparra, 180. La oliva cruza la península. Cerca o lejos, todo elegido por sabor — no por proximidad.',
};

export const TORTILLA_DECONSTRUCTED = {
  id: 'tortilla-deconstruida',
  eyebrow: 'Receta deconstruida',
  titleParts: ['Tortilla casera, ', { em: 'de la huerta a la barra.' }],
  sub: 'Patata cántabra, huevo fresco y un chorro de aceite. Sin atajos. Hecha cada mañana en casa.',
  plateImg: '/dishes/tortilla.jpg',
  plateAlt: 'Tortilla española deconstruida — patata cántabra, huevo fresco, aceite de oliva, cebolla y sal',
  ingredients: [
    {
      key: 'patata',
      name: 'Patata',
      pos: 'tl',
      origin: 'Valle del Pas · Cantabria',
      distance: '25 km',
      note: 'Patata de la tierra, cortada a mano en láminas finas. Pochada lenta. La textura lo es todo.',
      img: '/dishes/ing-patata.jpg',
    },
    {
      key: 'huevo',
      name: 'Huevo fresco',
      pos: 'tr',
      origin: 'Granja local · Cantabria',
      distance: '30 km',
      note: 'Huevos camperos del día. Yema naranja, clara firme. Marca el sabor.',
      img: '/dishes/ing-huevo.jpg',
    },
    {
      key: 'aceite',
      name: 'Aceite de oliva',
      pos: 'bl',
      origin: 'Jaén · Andalucía',
      distance: '750 km',
      note: 'Virgen extra, picual. Para pochar lento sin que pierda alma.',
      img: '/dishes/ing-aceite.jpg',
    },
    {
      key: 'cebolla',
      name: 'Cebolla',
      pos: 'br',
      origin: 'Huerta local',
      distance: '15 km',
      note: 'Cebolla blanca, pochada hasta el dorado. La eterna polémica: en el Cabrero, sí.',
      img: '/dishes/ing-cebolla.jpg',
    },
    {
      key: 'sal',
      name: 'Sal de Cabo Mayor',
      pos: 'top',
      origin: 'Costa cántabra',
      distance: '40 km',
      note: 'Sal marina cántabra. Una pizca, justa. La que despierta el resto.',
      img: '/dishes/ing-sal.jpg',
    },
  ],
  map: {
    center: { x: 280, y: 200 },
    markers: [
      { key: 'center',  x: 280, y: 200, label: 'Torrelavega', center: true },
      { key: 'patata',  x: 220, y: 245, label: 'Valle del Pas', km: 25 },
      { key: 'huevo',   x: 340, y: 235, label: 'Granja local',  km: 30 },
      { key: 'sal',     x: 300, y: 110, label: 'Cabo Mayor',    km: 40 },
      { key: 'aceite',  x: 145, y: 285, label: 'Jaén',          km: 750 },
    ],
  },
  mapNote: 'La patata, el huevo y la sal vienen de Cantabria. El aceite viene de Jaén — porque el mejor virgen extra del mundo está allí. Producto de cerca y producto excelente, sin dogma.',
};
